import { render, staticRenderFns } from "./SubAreasSelection.vue?vue&type=template&id=3e4d519b&scoped=true"
import script from "./SubAreasSelection.vue?vue&type=script&lang=js"
export * from "./SubAreasSelection.vue?vue&type=script&lang=js"
import style0 from "./SubAreasSelection.vue?vue&type=style&index=0&id=3e4d519b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4d519b",
  null
  
)

export default component.exports